<template>
  <div>
    <BaseDialog
      v-model="showDialog"
      :title="title"
      :dialogIcon="dialogIcon"
      btnActionName="Eksporter"
      @action="$emit('action')"
    >
      <template v-slot>
        <v-alert v-if="noColumnsSelected" outlined type="warning" dense>
          {{ alertMessage }}
        </v-alert>
        <div v-for="(item, index) in items" :key="index">
          <v-checkbox
            v-model="item[valueKey]"
            :label="item[nameKey]"
            :color="color"
            hide-details
          ></v-checkbox>
        </div>
      </template>

      <template v-slot:btn>
        <slot name="btn"></slot>
      </template>
    </BaseDialog>
  </div>
</template>

<script>
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

import { columnsObject } from "@/types/tableInterface";
export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    data: {
      default: [],
    },
    valueKey: {
      type: String,
      default: "exportCol",
    },
    nameKey: {
      type: String,
      default: "name",
    },
    color: {
      type: String,
      default: "primary",
    },
    "alert-message": {
      default: "En kollone må være valgt for å kunne eksportere tabell",
    },
    dialogIcon: {
      type: String,
    },
  },
  data() {
    return {
      smsSendt: false,
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    items: {
      get() {
        return this.data;
      },
      set(data) {
        this.$emit("update:data", data);
      },
    },
    noColumnsSelected() {
      if (this.items.length > 0) {
        const someIsSelected = this.items.some((x) => x[this.valueKey]);
        return !someIsSelected;
      }
      return true;
    },
  },
  components: {
    BaseDialog,
  },
});
</script>
